<template>
  <div>
    <label class="btn-switch btn-switch--toggle">
      <input
        type="checkbox"
        :checked="checked"
        @change="$emit('click', $event)"
        :disabled="disabled"
      />
      <span data-testid="toggle" class="slider align-middle"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  props: {
    selected: {
      type: Boolean,
      defaultValue: false
    },
    disabled: {
      type: Boolean,
      defaultValue: false
    }
  },
  computed: {
    checked: function () {
      return this.selected
    }
  }
}
</script>

<style lang="scss" scoped>
/* TODO take styles from layout, not use layout styles */
</style>
